import { CircularProgress, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { BillsVService } from '../../../services/V2/gozer';
import { formatShortDate } from '../../shared/Functions';

export function Bill({ hide, show, billingAccountId, bill, fail }) {
    const [src, setSrc] = useState<string>("");

    useEffect(() => {
        if(!bill) return
        else {
            BillsVService.billsVGetAttachment(billingAccountId, bill.id)
                .then(x => setSrc(x.preSignedUrl ?? "error"))
                .catch(err => setSrc("error"))
        }
    }, [billingAccountId, bill])// eslint-disable-line react-hooks/exhaustive-deps

    return <>
        <Dialog onClose={hide} open={show} fullWidth>
            <DialogContent>
                <h5>Billing Statement {bill?.billingCycle ? formatShortDate(bill.billingCycle.cycleMonth - 1, bill.billingCycle.cycleYear) : ""}</h5>
                {src === "" ?
                    <div className='loading-container'><CircularProgress className='center-spinner' color="primary"  /></div> :
                    src === "error" ?
                        <div style={{ textAlign:"center" }}>There was an error loading the bill.</div> :
                        <iframe title="bill" style={{ width: "100%", height: "75vh" }} src={src} />
                }
            </DialogContent>
            <DialogActions>
                <button
                    className='uvp-button green-button'
                    style={{
                        margin: "10px",
                        padding: "5px 10px",
                        width: "120px",
                        textTransform: "none"
                    }}
                    onClick={hide}
                >
                    Close
                </button>
            </DialogActions>
        </Dialog>
    </>
}
